<div class="cm-session-title">
  <mat-checkbox
    [checked]="cmSession.selected == 'true'"
    [indeterminate]="cmSession.selected == 'partially'"
    (change)="selectCMSession($event.checked)"
    [disabled]="isLayerLoading$()"
  >
    {{ cmSession.session_name }}
  </mat-checkbox>
</div>

<div class="cm-session-buttons">
  @if (isLoading$()) {
    <button matIconButton><mat-spinner diameter="24"></mat-spinner></button>
  } @else {
    <button
      matIconButton
      aria-label="Export all results in ZIP"
      matTooltip="Export all results in ZIP"
      (click)="exportCMFilesToZIP()"
    >
      <mat-icon>folder_zip</mat-icon>
    </button>

    @if (
      (cmSession.results.csv_files?.length ?? 0) > 0 ||
      (cmSession.results.extra_zip_files?.length ?? 0) > 0
    ) {
      <button
        matIconButton
        aria-label="Export extra file(s)"
        matTooltip="Export extra file(s)"
        (click)="exportExtraOutputFilesCM()"
      >
        <mat-icon>archive</mat-icon>
      </button>
    }
    <button
      matIconButton
      aria-label="Delete CM session"
      matTooltip="Delete CM session"
      (click)="clickOnDelete()"
    >
      <mat-icon>delete_forever</mat-icon>
    </button>
    @if (isConnected$() && cmSession.id == undefined) {
      <!-- ! tooltip must be outside because button disabled hide tooltip -->
      @let spaceState = stillSpaceOnAccountState$();
      <div
        [matTooltip]="
          spaceState.status !== 'success'
            ? 'You cannot add a CM session right now. Try again later.'
            : spaceState.data
              ? 'Save CM session'
              : 'Your account is already full. Delete data to add new sessions.'
        "
      >
        <button
          matIconButton
          aria-label="Save CM session"
          [disabled]="spaceState.status !== 'success' || !spaceState.data"
          (click)="clickOnSave()"
        >
          <mat-icon>save</mat-icon>
        </button>
      </div>
    }
  }
</div>

<ul class="cm-session-layers">
  <!-- RASTER LAYERS -->
  @for (layer of cmSession.results.raster_layers; track $index) {
    <mat-card class="layer-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title-group class="layer-header">
          <mat-card-title>
            <mat-checkbox
              [checked]="layer.selected"
              (change)="selectCMSessionLayer($event.checked, $index, RASTER_TYPE)"
              [disabled]="isLayerLoading$() || isLayerLoading(layer.path)"
            >
              {{ layer.name }}
            </mat-checkbox>
          </mat-card-title>
          @if (isLayerLoading(layer.path)) {
            <mat-spinner [diameter]="20"></mat-spinner>
          }
        </mat-card-title-group>
      </mat-card-header>

      @if (layer.selected) {
        <app-card-layer-cm
          [layer]="layer"
          [format]="RASTER_TYPE"
          [cmSession]="cmSession"
        ></app-card-layer-cm>
      }
    </mat-card>
  }

  <!-- GEOJSON LAYERS -->
  @for (layer of cmSession.results.geojson_layers; track $index) {
    <mat-card class="layer-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title-group class="layer-header">
          <mat-card-title>
            <mat-checkbox
              [checked]="layer.selected"
              (change)="selectCMSessionLayer($event.checked, $index, GEOJSON_TYPE)"
              [disabled]="isLayerLoading$() || isLayerLoading(layer.path)"
            >
              {{ layer.name }}
            </mat-checkbox>
          </mat-card-title>
          @if (isLayerLoading(layer.path)) {
            <mat-spinner [diameter]="20"></mat-spinner>
          }
        </mat-card-title-group>
      </mat-card-header>

      @if (layer.selected) {
        <app-card-layer-cm
          [layer]="layer"
          [format]="GEOJSON_TYPE"
          [cmSession]="cmSession"
        ></app-card-layer-cm>
      }
    </mat-card>
  }

  <!-- VECTOR LAYERS -->
  @for (layer of cmSession.results.vector_layers; track $index) {
    <mat-card class="layer-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>
            <mat-checkbox
              [checked]="layer.selected"
              (change)="selectCMSessionLayer($event.checked, $index, VECTOR_TYPE)"
              [disabled]="isLayerLoading$() || isLayerLoading(layer.path)"
            >
              {{ layer.name }}
            </mat-checkbox>
          </mat-card-title>
          @if (isLayerLoading(layer.path)) {
            <mat-spinner [diameter]="20"></mat-spinner>
          }
        </mat-card-title-group>
      </mat-card-header>
      @if (layer.selected) {
        <app-card-layer-cm
          [layer]="layer"
          [format]="VECTOR_TYPE"
          [cmSession]="cmSession"
        ></app-card-layer-cm>
      }
    </mat-card>
  }
</ul>
